import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">读者热评</h2>
          <p className="mt-2 text-sm text-foreground-500">来自韩漫迷的真实反馈与热爱</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-foreground-400">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}